import { RUN_SCHEMA } from './core/runLog'
import { screenInfo } from './deviceInfo'
import { checkStartupOrder, sinceProcessStart } from './core/startupMarks'

// Assembles the JSON written for each run and each launch (core/runLog.js
// lists the required fields and validates them).

function header({ kind, build, deviceInfo, crash }) {
    const n = deviceInfo.native ?? {}
    return {
        schema: RUN_SCHEMA,
        kind,
        writtenAtEpochMs: Date.now(),
        build: {
            ...build,
            appId: n.appId ?? null,
            debuggable: n.debuggable ?? null,
            profileableByShell: n.profileableByShell ?? null,
            nativeBuildType: n.nativeBuildType ?? null,
            nativeCommit: n.nativeCommit ?? null,
        },
        device: deviceInfo.device,
        nativeInfo: n,
        screen: screenInfo(),
        crashCounter: crash,
    }
}

export function startupRecord({ marks, startup, firestoreSettings, crashBoot }) {
    return {
        marks,
        sinceProcessStartMs: sinceProcessStart(marks),
        orderProblems: checkStartupOrder(marks),
        authSource: startup?.authSource ?? null,
        uid: startup?.uid ?? null,
        doc: startup?.doc ?? null,
        errors: startup?.errors ?? [],
        firestoreSettings,
        crashBoot,
    }
}

export function buildStartupLog({ build, deviceInfo, crash, startup }) {
    return { ...header({ kind: 'startup', build, deviceInfo, crash }), startup }
}

export function buildRunLog({ result, build, deviceInfo, crash, stageInfo, startup, logger, jsErrors, armDelayMs }) {
    const { cfg } = result
    const durationMs = result.perfStartMs != null && result.perfStopMs != null ? result.perfStopMs - result.perfStartMs : null
    return {
        ...header({ kind: 'run', build, deviceInfo, crash }),
        runLabel: cfg.label,
        mode: cfg.mode,
        status: result.status,
        abortReason: result.abortReason ?? null,
        renderer: stageInfo,
        startup: startup ?? null,
        run: {
            traceName: result.traceName,
            timeOrigin: performance.timeOrigin,
            startedAtEpochMs: result.startedAtEpochMs ?? null,
            perfStartMs: result.perfStartMs,
            perfStopMs: result.perfStopMs,
            durationMs,
            armDelayMs,
            armedAtPerfMs: result.armedAtPerfMs,
            debugUnmountedAtPerfMs: result.debugUnmountedAtPerfMs,
            beat: result.beat,
            sustainedDurationMs: cfg.mode === 'sustained' ? cfg.durationMs : null,
            beatsCompleted: result.beatsCompleted,
            flash: !!cfg.flash,
            nativeBegin: result.nativeBegin,
            nativeEnd: result.nativeEnd,
            jsErrors,
            inject: result.inject ?? null,
            drawCalls: result.drawCalls ?? null,
            memory: result.memory ?? null,
        },
        frames: {
            clock: 'performance.now() in the PixiJS ticker callback, ms',
            count: logger.count,
            capacity: logger.capacity,
            overflow: logger.overflow,
            timestampsMs: logger.timestamps(),
        },
    }
}
